import { render, staticRenderFns } from "./LayerDialog.vue?vue&type=template&id=38acae9c&scoped=true&"
import script from "./LayerDialog.vue?vue&type=script&lang=js&"
export * from "./LayerDialog.vue?vue&type=script&lang=js&"
import style0 from "./LayerDialog.vue?vue&type=style&index=0&id=38acae9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38acae9c",
  null
  
)

export default component.exports